export interface MediaUploadProps {
  fieldName: string;
}
